
<div class="empty">

  <div class="center">
    <img src="../assets/images/empty.png"/>
    <span>無符合條件顯示結果</span>
  </div>
  
</div>
